export const RESOURCE_NAME = 'purchase_aggregation';

export const ENTITY_NAME = 'purchasesStatistics';
